import { AppRoutePath } from 'config/constants';
import { matchPath, useMatch } from 'react-router-dom';

type ViewerWindowId = '0' | '1';

export const getViewerWindowIdFromUrl = (url: string): ViewerWindowId | null => {
  let pathname = url;
  try {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      pathname = new URL(url).pathname;
    } else {
      pathname = url.split('?')[0];
    }
  } catch {
    pathname = url.split('?')[0];
  }

  const viewerCaseMatch = matchPath({ path: AppRoutePath.VIEWER, end: false }, pathname);
  if (viewerCaseMatch?.params?.windowId === '0' || viewerCaseMatch?.params?.windowId === '1') {
    return viewerCaseMatch.params.windowId as ViewerWindowId;
  }
  const viewerBlankMatch = matchPath({ path: AppRoutePath.VIEWER_BLANK, end: false }, pathname);
  if (viewerBlankMatch?.params?.windowId === '0' || viewerBlankMatch?.params?.windowId === '1') {
    return viewerBlankMatch.params.windowId as ViewerWindowId;
  }

  return null;
};

export const useViewerMatch = () => {
  const match = useMatch(AppRoutePath.VIEWER);
  const blankMatch = useMatch(AppRoutePath.VIEWER_BLANK);

  return match ?? blankMatch;
};
